import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/service/navigation.service';

@Component({
    selector: 'help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
    constructor(private navigationService: NavigationService) { }

    ngOnInit(): void {
        this.navigationService.activity.setupQuickly('Справка');
    }
}
